import React from 'react';
import { galleryImages } from '../data/mockData';

const GallerySection = () => {
  return (
    <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Galerie Saale Lounge
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full mb-6" />
          <p className="text-white/70 text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Eindrücke aus der Saale Lounge Hammelburg
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryImages.map((image) => (
            <div 
              key={image.id} 
              className="relative overflow-hidden rounded-lg group cursor-pointer aspect-square"
            >
              <img 
                src={image.url} 
                alt={image.alt}
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bg-dark/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {image.alt}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
